export enum EdtrSlots {
	ADD_RECURRING_DATE_OPTION = 'add-recurring-date-option',
	ADD_SINGLE_DATE_OPTION = 'add-single-date-option',
	AFTER_DATES_LIST = 'after-datetimes-list',
	AFTER_TICKETS_LIST = 'after-tickets-list',
	BEFORE_DATES_LIST = 'before-datetimes-list',
	BEFORE_TICKETS_LIST = 'before-tickets-list',
	EDIT_DATE_MODAL_FOOTER = 'edit-date-modal-footer',
	EDIT_TICKET_MODAL_FOOTER = 'edit-ticket-modal-footer',
	REM_MODAL_FOOTER = 'rem-modal-footer',
}
